import $ from 'jquery';
import 'jquery-trend';
import 'jquery-revealer';
import CurrencyConverter from 'shopify-currency-converter';
import ShopifyVariants from 'shopify-variants';

import AddToCartButton from './AddToCartButton';
import CartMini from './CartMini';
import RTE from './RTE';
import ShareThis from './ShareThis';
import ProductGallery from './ProductGallery';

export default class Product {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);
    this.data = component.data;
    this.onScroll = this.onScroll.bind(this);
    this.setupProductDetails = this.setupProductDetails.bind(this);

    this.window = $(window);
    this.productArea = $('.product-area', this.el);
    this.thumbsCount = this.productArea.find('.thumb').length;

    this.productDetailsWrapper = this.productArea.find('.product-details-wrapper');
    this.productDetails = this.productArea.find('.product-details');
    this.$productToggleFullview = $('.product-toggle-fullview', this.el);

    this.productGallery = new ProductGallery(
      this.el.querySelector('[data-product-gallery]'),
      {
        enable_video_autoplay: this.data.settings.gallery_enable_video_autoplay,
        enable_video_looping: this.data.settings.gallery_enable_video_looping,
      },
    );

    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];

    for (let i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new RTE(this.rteEls[i]));
    }

    this.addToCartTrigger = this.el.querySelector('[data-product-submit]');
    this.addToCartButton = new AddToCartButton(this.addToCartTrigger);

    this.cartMini = new CartMini();

    this.selectedThumbIndex = 0;
    this.processing = false;

    this.eventId = `product-${this.el.id}`;

    if (this.data.settings.thumbOrientation === 'list') {
      this.setupProductDetails();
      this.window.on(`load.${this.eventId} resize.${this.eventId}`, this.setupProductDetails);
      this.window.on(`scroll.${this.eventId}`, this.setupProductDetails);
    }

    this.window.on(`shopify-variants:switch-variant.${this.eventId}`, (event, data) => this._onVariantSwitch(data.product, data.variant));
    this.setupVariants();
    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    $('.product-area .submit', this.el).on('click.product', e => {
      e.preventDefault();
      this.addToCart();
    });
    $('.product-area .single-option-selector', this.el).on('change.product', this.resetErrors.bind(this));

    this.shareThisEl = this.el.querySelector('[data-sharethis]');

    if (this.shareThisEl) {
      this.sharethis = new ShareThis(this.shareThisEl, this.productArea[0]);
    }
  }

  setupVariants() {
    const $variants = $('[data-variants]', this.el);
    const $options = $('[data-product-option]', this.el);

    if ($variants.length && $options.length) {
      this.variantHelpers = new ShopifyVariants(this.data.product, $variants, $options);
    } else {
      // Products with variants are converted by the initial variant switch,
      // but product without need to be converted, if they haven't already
      this.el.querySelectorAll('.money:not([data-currency])')
        .forEach(money => CurrencyConverter.update(money));
    }
  }

  onScroll() {
    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    if (
      (viewportWidth > 770)
      && (viewportHeight > this.detailsHeight)
    ) {
      this.positionProductInfo(this.stickyNavHeight, this.detailsHeight);
    } else {
      this.productDetails.css('position', 'static');
    }
  }

  setupProductDetails() {
    this.mainHeaderWrap = $('.main-header-wrap');

    this.productDetails.width(this.productDetailsWrapper.width());

    if (this.mainHeaderWrap.attr('data-header-layout') !== 'minimal') {
      this.stickyNavHeight = 0;
      this.detailsWrapperOffset = this.productDetailsWrapper.offset().top - this.stickyNavHeight;
      this.detailsHeight = this.productDetails.outerHeight(true) + this.stickyNavHeight;
    } else {
      this.stickyNavHeight = $('.header-minimal').outerHeight(true);
      this.detailsWrapperOffset = this.productDetailsWrapper.offset().top;
      this.detailsHeight = this.productDetails.outerHeight(true);
    }

    this.productDetailsWrapper.css({
      position: 'sticky',
      top: 0,
    });

    if (window.getComputedStyle(this.productDetailsWrapper[0]).position.indexOf('sticky') === -1) {
      this.onScroll();
    }
  }

  positionProductInfo(stickyNavHeight, detailsHeight) {
    const productImages = this.productArea.find('[data-product-gallery]');
    const scrollTop = this.window.scrollTop() + stickyNavHeight;
    const imagesBottom = productImages.offset().top + productImages.outerHeight(true);

    if (this.productDetails.outerHeight() >= productImages.outerHeight(true)) { return; }

    this.productDetails.css({
      position: 'fixed',
      top: (imagesBottom - detailsHeight) > scrollTop
        ? Math.max(0, productImages.offset().top - scrollTop)
        : (imagesBottom - detailsHeight) - scrollTop,
    });
  }

  handleErrors(response) {
    const error = JSON.parse(response.responseText);

    $('[data-product-form]', this.el).append(`<div class="error-message">${error.description}</div>`);

    this.timeout = setTimeout(() => {
      this.processing = false;
      this.addToCartButton.setState('error');
      setTimeout(() => this.addToCartButton.resetState(), 1000);
    }, 1000);
  }

  resetErrors() {
    $('.error-message', this.el).remove();
    this.processing = false;
  }

  addToCart() {
    if (this.processing) { return; }

    // Connect error handler
    // We need to do this each time because the quickshop might override it
    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);

    this.resetErrors();
    this.processing = true;
    this.addToCartButton.setState('loading');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $('[data-product-form]', this.el).serialize(),
      success: () => {
        if (this.data.settings.enable_cart_redirect) {
          window.location = '/cart';
          return;
        }

        this.cartMini.refresh();
        this.timeout2 = setTimeout(() => {
          this.addToCartButton.setState('success');
          this.cartMini.open();

          this.timeout3 = setTimeout(() => {
            this.addToCartButton.resetState();
            this.processing = false;
          }, 1000);
        }, 1000);
      },
      error: this.handleErrors.bind(this),
      dataType: 'json',
    });
  }

  unload() {
    clearTimeout(this.timeout);
    clearTimeout(this.timeout2);
    clearTimeout(this.timeout3);
    this.rtes.forEach(rte => rte.unload());
    this.window.off(`.${this.eventId}`);
    $(document).off('click.product');
    $('.product-area .thumb', this.el).off('click.product');
    $('.product-area .submit', this.el).off('click.product');
    $('.modal-wrap .close', this.el).off('click.product');
    $('.product-area .single-option-selector', this.el).off('change.product');

    if (this.variantHelpers) {
      this.variantHelpers.unload();
    }

    if (this.shareThis) {
      this.sharethis.unload();
    }

    this.productGallery.unload();
  }

  _onVariantSwitch(product, variant) {
    if (product !== this.data.product) {
      return;
    }

    const { options } = variant;
    const $options = $('[data-product-option]', this.el);

    options.forEach((option, index) => {
      $options.eq(index).siblings('[data-selected-option]').text(option);
    });

    $('[data-product-variant-sku]', this.el).text(variant.sku || '');

    this._updatePrice(variant);
    this.productGallery.selectMediaByVariant(variant);
    this._updateHistory(variant);
  }

  _updatePrice(variant) {
    const $addToCartButton = $('[data-product-submit]', this.productArea);
    const $priceFields = $('.product-details .price', this.productArea);

    if (variant) {
      if (variant.available) {
        $addToCartButton
          .val(this.data.locale.add_to_cart)
          .removeClass('disabled')
          .removeAttr('disabled');
      } else {
        $addToCartButton
          .val(this.data.locale.sold_out)
          .addClass('disabled')
          .attr('disabled', 'disabled');
      }

      if (variant.compare_at_price > variant.price) {
        $priceFields
          .find('.money:not(.original)')
          .html(window.Shopify.formatMoney(variant.price, this.data.settings.money_format));
        $priceFields
          .find('.money.original')
          .html(window.Shopify.formatMoney(variant.compare_at_price, this.data.settings.money_format))
          .removeClass('hidden');
      } else {
        $priceFields
          .find('.money:not(.original)')
          .html(window.Shopify.formatMoney(variant.price, this.data.settings.money_format));
        $priceFields
          .find('.money.original')
          .addClass('hidden');
      }
    } else {
      // Variant doesn't exist
      $addToCartButton
        .val(this.data.locale.unavailable)
        .addClass('disabled')
        .attr('disabled', 'disabled');
    }

    $priceFields.find('.money').each((index, element) => CurrencyConverter.update(element));
  }

  _updateHistory(variant) {
    if (!this.data.settings.enable_history || (variant == null)) { return; }

    const newUrl = [
      window.location.protocol,
      '//',
      window.location.host,
      window.location.pathname,
      '?variant=',
      variant.id,
    ];

    const variantUrl = newUrl.join('');
    window.history.replaceState({ path: variantUrl }, '', variantUrl);
  }
}
